'use strict';

import tools from './tools/tools';
import storage from './storage/storage';
import Reporter from './reporter/reporter';
import LoggerInstance from './logger-instance';
import WidgetLoggerInstance from './widget-logger-instance';
import ErrorHandler from './error-handler';
import {BI_BASE_URL, SESSION_ID_STORAGE_KEY, DEFAULT_APP_VERSION} from './conf';

function getSessionId() {
  let res = typeof window !== 'undefined' && window.fedops && window.fedops.sessionId;
  res = res || storage.getItem(SESSION_ID_STORAGE_KEY);
  res = res || tools.generateGuid();

  storage.setItem(SESSION_ID_STORAGE_KEY, res);

  return res;
}

let ReporterFactory = Reporter; // good for tests

export function setFactory(factory) {
  ReporterFactory = factory;
}
/**
 * Builds a logger instance.
 */
export default class LoggerBuilder {

  setAppName(name) {
    this.appName = name;
    return this;
  }

  setAppVersion(version) {
    this.appVersion = version;
    return this;
  }

  setErrorHandlerToggle(toggle) {
    this.errorHandlerToggle = toggle;
    return this;
  }

  setSwallowExceptions(swallow) {
    this.swallowExceptions = swallow;
    return this;
  }

  setAppId(appId) {
    this.appId = appId;
    return this;
  }

  setBaseUrl(url) {
    this.baseUrl = url;
    return this;
  }

  setWidgetLogger(isWidgetLogger) {
    this.isWidgetLogger = isWidgetLogger;
    return this;
  }

  setInteractionTimeout(interactionTimeout) {
    this.interactionTimeout = interactionTimeout;
    return this;
  }

  setTimeoutHook(timeoutHook) {
    this.timeoutHook = timeoutHook;
    return this;
  }

  setStartHook(startHook) {
    this.startHook = startHook;
    return this;
  }

  setEndHook(endHook) {
    this.endHook = endHook;
    return this;
  }

  setDisableAutoLoadFinish(disableAutoLoadFinish) {
    this.disableAutoLoadFinish = disableAutoLoadFinish;
    return this;
  }

  build() {
    if (!this.appName) {
      return null;
    }

    if (!this.appVersion) {
      this.appVersion = DEFAULT_APP_VERSION;
    }

    const reporter = new ReporterFactory(this.baseUrl || BI_BASE_URL);
    const errorHandlerToggle = this.errorHandlerToggle;
    const swallowExceptions = this.swallowExceptions;
    const interactionTimeout = this.interactionTimeout;
    const timeoutHook = this.timeoutHook;
    const startHook = this.startHook;
    const endHook = this.endHook;
    const disableAutoLoadFinish = this.disableAutoLoadFinish;

    if (errorHandlerToggle) {
      window.fedopsLoggerErrorHandler = window.fedopsLoggerErrorHandler || new ErrorHandler({swallowExceptions});
    }

    let logger = null;

    if (this.isWidgetLogger) {
      logger = new WidgetLoggerInstance(this.appName, this.appVersion, reporter, {sessionId: getSessionId(), errorHandlerToggle, swallowExceptions, disableAutoLoadFinish});
    } else {
      logger = new LoggerInstance(this.appName, this.appVersion, reporter, {sessionId: getSessionId(), errorHandlerToggle, swallowExceptions, disableAutoLoadFinish, interactionTimeout, timeoutHook, startHook, endHook});
    }

    return logger;
  }
}



// WEBPACK FOOTER //
// ./logger-builder.js